const BADGE_BY_STATUS = {
  OK: {
    label: "OK",
    toneClass: "border-emerald-500/20 bg-emerald-500/10 text-emerald-300",
  },
  WARN: {
    label: "WARN",
    toneClass: "border-amber-500/20 bg-amber-500/10 text-amber-300",
  },
  BAD: {
    label: "BAD",
    toneClass: "border-red-500/20 bg-red-500/10 text-red-300",
  },
  "N/A": {
    label: "—",
    toneClass: "border-slate-500/20 bg-slate-500/10 text-slate-300",
  },
};

export const normalizeObjectiveStatus = (status) => {
  const normalized = String(status || "N/A").toUpperCase();
  return BADGE_BY_STATUS[normalized] ? normalized : "N/A";
};

export const objectiveBadge = (status) => {
  const normalizedStatus = normalizeObjectiveStatus(status);
  return {
    status: normalizedStatus,
    ...BADGE_BY_STATUS[normalizedStatus],
  };
};
